import sudan from  "../assets/sudan.jpg";
import space from  "../assets/space.jpg";
import wlabor from  "../assets/wlabor.jpg";
import smash from  "../assets/smash.jpg";
import we from "../assets/we.jpg";
import wh from "../assets/wh.jpg";
import ladder from "../assets/ladder.png";
import mic from "../assets/mic.jpg";
import seeds from "../assets/seeds.jpg";
import ladywork from "../assets/ladywork.jpg";
import daisy from "../assets/daisy.jpg";
import ed from "../assets/ed.jpg";

 const photos = [
    {
      src: sudan,
      width: 1,
      height: 1
    },
    {
      src: space,
      width: 1,
      height: 1
    },
    {
      src: seeds,
      width: 1,
      height: 1
    },
    {
      src: wlabor,
      width: 1,
      height: 1
    },
    {
      src: smash,
      width: 1,
      height: 1
    },
    {
      src: mic,
      width: 1,
      height: 1
    },
    {
      src: we,
      width: 1,
      height: 1
    },
    {
      src: wh,
      width: 1,
      height: 1
    }, {
      src: ladywork,
      width: 1,
      height: 1
    },
    {
      src: ed,
      width: 1,
      height: 1
    },
    {
      src: daisy,
      width: 1,
      height: 1
    },
    {
      src: ladder,
      width: 1,
      height: 1
    },
  
    
]  
export default photos;